import Icon from "@ant-design/icons";
import React from "react";

export default function NotificationIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 5C13 5.55228 12.5523 6 12 6C11.4477 6 11 5.55228 11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5ZM12 6C8.13401 6 5 9.13401 5 13V15.1684C4.40876 15.4493 4 16.0519 4 16.75V18.25C4 19.2165 4.7835 20 5.75 20H18.25C19.2165 20 20 19.2165 20 18.25V16.75C20 16.0519 19.5912 15.4493 19 15.1684V13C19 9.13401 15.866 6 12 6ZM17.5 13V15H6.5V13C6.5 9.96243 8.96243 7.5 12 7.5C15.0376 7.5 17.5 9.96243 17.5 13ZM18.5 16.75V18.25C18.5 18.3881 18.3881 18.5 18.25 18.5H5.75C5.61193 18.5 5.5 18.3881 5.5 18.25V16.75C5.5 16.6119 5.61193 16.5 5.75 16.5H18.25C18.3881 16.5 18.5 16.6119 18.5 16.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
